import { render, staticRenderFns } from "./ReceivingSnapshot.vue?vue&type=template&id=02f9fddc"
import script from "./ReceivingSnapshot.vue?vue&type=script&lang=js"
export * from "./ReceivingSnapshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports